import React from 'react';
import type { FC } from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { useSessionData } from '@confluence/session-data';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';
import { CopySpacePermissionsAndDefaultPermissionsLoader } from '@confluence/copy-space-permissions/entry-points/CopySpacePermissionsAndDefaultPermissions';

import { JSMPrompt } from '../../entry-points/SpacePermissionsSettingsTab';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const CopySpaceContainer = styled.div({
	padding: `${token('space.075')}`,
});

export const SpacePermissionsSharedHeader: FC<{ spaceKey: string }> = ({ spaceKey }) => {
	const { edition } = useSessionData();

	const isFreeTenant = edition === ConfluenceEdition.FREE;

	return (
		<>
			{isFreeTenant ? null : <JSMPrompt spaceKey={spaceKey} />}
			{isFreeTenant ? null : (
				<CopySpaceContainer>
					<CopySpacePermissionsAndDefaultPermissionsLoader />
				</CopySpaceContainer>
			)}
		</>
	);
};
